import getRuntimeEnv from './env';
import { IAuthenticationProfile } from '../redux/reducers/authentication';

export const ALLOW_LABELS_GROUP =
  getRuntimeEnv().REACT_APP_ALLOW_SHOW_SUBLABELS_GROUP;

/**
 * hasExternalViewSublabelsGroup checks if the currently logged in user has access to view labels.
 * @param {*} profile
 * @returns {boolean}
 */

export function hasExternalViewLabelsGroup(
  profile?: IAuthenticationProfile
): boolean {
  if (!profile || !ALLOW_LABELS_GROUP) {
    return false;
  }

  return profile.groups?.includes(ALLOW_LABELS_GROUP) ?? false;
}
